document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.richtext ul').forEach(function (ul) {
    const style = window.getComputedStyle(ul);
    const listStyle = style.getPropertyValue('list-style-type');

    // If the computed style is 'none' or 'initial', set it to 'disc'
    if (listStyle === 'none' || listStyle === 'initial') {
      ul.style.listStyleType = 'disc';
    }
  });

  const currentHost = window.location.hostname;
  const links = document.querySelectorAll('.richtext a[href]');

  console.log('currentHost', currentHost);

  if (links.length > 0) {
    links.forEach((link) => {
      try {
        const url = new URL(link.href);

        if (url.hostname !== currentHost) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      } catch (e) {}
    });
  }
});